"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParcelNinjaSendModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var main_1 = require("../../../../../../../reducers/slices/main");
var update_parcel_thunk_1 = require("../../../../../../../reducers/slices/parcels/thunks/update_parcel_thunk");
var get_parcel_thunk_1 = require("../../../../../../../reducers/slices/parcels/thunks/get_parcel_thunk");
var parcel_ninja_quotes_modal_1 = require("./parcel_ninja_quotes_modal");
var add_parcel_dimensions_1 = __importDefault(require("./add_parcel_dimensions"));
var update_parcel_metadata_1 = require("../../../../../../../api/calls/parcel/update/update_parcel_metadata");
var orders_1 = require("../../../../../../../reducers/slices/orders/orders");
var update_address_component_1 = require("../../update_address_component");
var update_delivery_address_1 = require("../../../../../../../api/calls/order/update/update_delivery_address");
var get_order_thunk_1 = require("../../../../../../../reducers/slices/orders/thunks/get_order_thunk");
var constants_1 = require("../../../../../../../constants/constants");
var ParcelNinjaSendModal = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var parcel_id = _a.parcel_id, onConfirm = _a.onConfirm;
    var dispatch = (0, react_redux_1.useDispatch)();
    var parcel = (0, react_redux_1.useSelector)(function (state) { return state.parcelState; }).parcel;
    var _k = (0, react_redux_1.useSelector)(function (state) { return state.orderState.selectedOrder; }), order_id = _k._id, delivery_address = _k.delivery_address;
    var updateParcelDimensions = function (dimensions) {
        var callback = function () { return dispatch((0, get_parcel_thunk_1.get_parcel_thunk)({ _id: parcel._id })); };
        dispatch((0, update_parcel_thunk_1.update_parcel_thunk)({
            callback: callback,
            payload: {
                _id: parcel._id,
                payload: {
                    dimensions: __assign({}, dimensions),
                },
            },
        }));
    };
    var hasDimensions = Object.keys((_b = parcel === null || parcel === void 0 ? void 0 : parcel.dimensions) !== null && _b !== void 0 ? _b : {}).length > 0;
    var dimensionErrors = function () {
        var _a, _b, _c, _d;
        var length = parseInt((_a = parcel === null || parcel === void 0 ? void 0 : parcel.dimensions) === null || _a === void 0 ? void 0 : _a.length);
        var width = parseInt((_b = parcel === null || parcel === void 0 ? void 0 : parcel.dimensions) === null || _b === void 0 ? void 0 : _b.width);
        var height = parseInt((_c = parcel === null || parcel === void 0 ? void 0 : parcel.dimensions) === null || _c === void 0 ? void 0 : _c.height);
        var weight = parseInt((_d = parcel === null || parcel === void 0 ? void 0 : parcel.dimensions) === null || _d === void 0 ? void 0 : _d.weight);
        return {
            length: (length < 1 || length > 270) && "Length must be between 1cm and 270cm",
            width: (width < 1 || width > 270) && "Width must be between 1cm and 270cm",
            height: (height < 1 || height > 270) && "Height must be between 1cm and 270cm",
            weight: (weight < 1 || weight > 100000) && "Weight must be between 1 gram and 100000 grams",
        };
    };
    (0, react_1.useEffect)(function () {
        if (parcel_id && (!parcel || (parcel === null || parcel === void 0 ? void 0 : parcel._id) !== parcel_id)) {
            dispatch((0, get_parcel_thunk_1.get_parcel_thunk)({ _id: parcel_id }));
        }
    }, []);
    var addressValid = Boolean(((_c = delivery_address.full_address) === null || _c === void 0 ? void 0 : _c.length) &&
        ((_d = delivery_address.line_one) === null || _d === void 0 ? void 0 : _d.length) &&
        (((_e = delivery_address.line_two) === null || _e === void 0 ? void 0 : _e.length) || ((_f = delivery_address.town) === null || _f === void 0 ? void 0 : _f.length)) &&
        ((_g = delivery_address.city) === null || _g === void 0 ? void 0 : _g.length) &&
        ((_h = delivery_address.province) === null || _h === void 0 ? void 0 : _h.length) &&
        ((_j = delivery_address.postal_code) === null || _j === void 0 ? void 0 : _j.length));
    var Component = function () {
        if (hasDimensions) {
            return ((0, jsx_runtime_1.jsx)(parcel_ninja_quotes_modal_1.ParcelNinjaQuotesModal, { parcel_id: parcel._id, onConfirm: function (quote) { return __awaiter(void 0, void 0, void 0, function () {
                    var response;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, (0, update_parcel_metadata_1.update_parcel_metadata)({
                                    _id: parcel._id,
                                    metadata: {
                                        label: "parcel_ninja_optimise_quote_id",
                                        value: quote.quote_id,
                                    },
                                })];
                            case 1:
                                response = _a.sent();
                                if (response === null || response === void 0 ? void 0 : response.success) {
                                    onConfirm(response === null || response === void 0 ? void 0 : response.content);
                                }
                                else {
                                    dispatch((0, main_1.setMessageModal)({ title: "Something went wrong saving your quote!", messages: [response === null || response === void 0 ? void 0 : response.message] }));
                                }
                                return [2 /*return*/];
                        }
                    });
                }); } }));
        }
        else if (!addressValid) {
            return ((0, jsx_runtime_1.jsx)(update_address_component_1.UpdateAddressComponent, { initialAddress: delivery_address, onAddressChange: function (new_delivery_address) { return __awaiter(void 0, void 0, void 0, function () {
                    var updated_address, response;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                dispatch((0, orders_1.setIsLoading)(true));
                                updated_address = Object.assign({}, delivery_address, new_delivery_address);
                                return [4 /*yield*/, (0, update_delivery_address_1.update_delivery_address)({
                                        _id: order_id,
                                        delivery_address: updated_address,
                                    })];
                            case 1:
                                response = _a.sent();
                                if (response.success) {
                                    dispatch((0, get_order_thunk_1.get_order_thunk)({ _id: order_id }));
                                }
                                else {
                                    dispatch((0, main_1.setMessageModal)({ title: constants_1.REQUEST_ERROR_TITLE, messages: [response.message] }));
                                    dispatch((0, orders_1.setIsLoading)(false));
                                }
                                return [2 /*return*/];
                        }
                    });
                }); } }));
        }
        return ((0, jsx_runtime_1.jsx)(add_parcel_dimensions_1.default, { parcel: parcel, onConfirm: function (dimensions) {
                updateParcelDimensions(dimensions);
            }, errors: dimensionErrors() }));
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col min-w-sm max-w-md max-h-[80vh]" }, { children: (0, jsx_runtime_1.jsx)(Component, {}) })));
};
exports.ParcelNinjaSendModal = ParcelNinjaSendModal;
